import { render, staticRenderFns } from "./patient-insurance.vue?vue&type=template&id=7572a3e5&scoped=true"
import script from "./patient-insurance.vue?vue&type=script&lang=js"
export * from "./patient-insurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572a3e5",
  null
  
)

export default component.exports